import { InterpolationValue } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';

/**
 * @deprecated please use ButtonDesignStyles
 */
export const ButtonVariants = {
  yellow: { secondary: ThemeColours.black, primary: ThemeColours.warning },
  red: { secondary: ThemeColours.white, primary: ThemeColours.negative },
  grey: { secondary: ThemeColours.black, primary: ThemeColours.mono100 },
  teal: { secondary: ThemeColours.white, primary: ThemeColours.primary },
  transparent: { secondary: ThemeColours.black, primary: 'transparent' },
  transparentTeal: { secondary: ThemeColours.primary, primary: 'transparent' },
  primary: { secondary: ThemeColours.buttonPrimaryText, primary: ThemeColours.buttonPrimaryFill },
  accent: {
    secondary: ThemeColours.buttonSecondaryText,
    primary: ThemeColours.buttonSecondaryFill,
  },
  transparentPrimary: { secondary: ThemeColours.primary, primary: 'transparent' },
} as const;

/**
 * @deprecated the replacing equivalent is ButtonDesignStyle
 */
export interface Variant {
  secondary: InterpolationValue;
  primary: InterpolationValue;
}
